import { Translatable } from "@icc/shared/helpers";

export class StaticBracket {
    id: number;
    @Translatable({ model: 'WindowAccessories' })
    name: string;
    /** Kod do indeksu */
    indexNo: string;
    /** Kod zewnętrzny */
    extId: string;
    /** Opis */
    description: string;
    /** Skrócony opis */
    shortDescription: string;
    printCode: string;
    /** Zdjęcie */
    img: string;
    /** Ilości */
    amounts: {
        /** Minimalna szerokość */
        min_width: number;
        /** Maksymalna szerokość */
        max_width: number;
        /** Ilość */
        amount: number;
        /** Typ wyboru */
        selection_type: 'mandatory' | 'suggested' | 'optional';
        /** Czy wyświetlać komunikat o dostępności */
        show_selection_type_announcement?: boolean;
    }[];
    /** Wymaga wzmocnienia poziomego dolnej części skrzynki */
    bottomHorizontalBoxReinforcement?: boolean;
    /** Domyślna ilość */
    defaultAmount?: number;
    /** Czy ustawione domyślnie */
    isDefault?: boolean;
    /** ID kategorii akcesoriów */
    categoryId?: number;
    /** Nazwa kategorii akcesoriów */
    categoryName?: string;
}

export interface IccStaticBracket {
    id: number;
    name: string;
    /** Kod do indeksu */
    indexNo: string;
    /** Kod zewnętrzny */
    extId: string;
    /** Opis */
    description: string;
    printCode: string;

    /** Skrócony opis */
    shortDescription: string;
    /** Zdjęcie */
    img: string;
    /** Ilości */
    amounts: {
        /** Minimalna szerokość */
        min_width: number;
        /** Maksymalna szerokość */
        max_width: number;
        /** Ilość */
        amount: number;
        /** Typ wyboru */
        selection_type: 'mandatory' | 'suggested' | 'optional';
        /** Czy wyświetlać komunikat o dostępności */
        show_selection_type_announcement?: boolean;
    }[];
    /** Przypisane typy produktu */
    shutterTypesIds: number[];
    /** Przypisane profile */
    profilesIds?: number[];
    /** Wymaga wzmocnienia poziomego dolnej części skrzynki */
    bottomHorizontalBoxReinforcement?: boolean;
    /** ID kategorii akcesoriów */
    categoryId?: number;
    /** Nazwa kategorii akcesoriów */
    categoryName?: string;
}

export interface StaticBracketAmount {
    amount: number;
    isDefault: boolean;
}
